import { serializeElementsForClipboard } from "../../../features/canvas/engine/clipboardOperations";

let fallbackClipboardText = null;

/**
 * Copies the engine's current selection: writes the payload to the system
 * clipboard (best effort — may be unavailable outside secure contexts) and
 * always keeps an in-memory fallback so paste works within the session.
 * @param {object} engine
 * @returns {boolean} whether anything was copied
 */
export const copyCanvasSelection = (engine) => {
  const selectedElements = engine.getSelectedElements();
  if (!selectedElements.length) return false;

  const clipboardText = serializeElementsForClipboard(selectedElements);
  fallbackClipboardText = clipboardText;
  navigator.clipboard?.writeText(clipboardText)?.catch(() => {});

  return true;
};

/**
 * @returns {string | null} the last payload copied in this session
 */
export const getClipboardFallbackText = () => fallbackClipboardText;
